module.exports = __webpack_public_path__ + "img/complementary-care-select-ru.39b40e95.jpg";